<template>
	<div class="container">
		<div class="main_box">
			<div class="footer_box"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div class="logo_box">
					<img src="../../assets/img/logo_color.png" @click="goIndex" />
				</div>
				<div class="footer_main">
					<div class="left">
						<div class="left_box_el">
							<div style="font-size: 16px;">© 2025 CorDx</div>
							<div style="font-size: 16px;">All Rights Reserved</div>
						</div>
						<div class="left_box_el">
							<div @click="navHandle('/about')">About</div>
							<div @click="navHandle('/partnering')">Partnering</div>
							<div @click="navHandle('/product/all')">Products</div>
						</div>
						<div class="left_box_el">
							<div @click="navHandle('/careers')">Careers</div>
							<div @click="navHandle('/contact')">Contact</div>
							<div @click="navHandle('/media-room')">Media Room</div>
							<div style="color: #706B69;font-size: 16px;">
								<a style="color: #999999 !important;" href="https://cordx.com/uploads/cordx_logo-pack_rev20220525.zip" target="_blank">Media Kit</a>
							</div>
						</div>
					</div>
					<div class="right">
						<div class="tit" style="padding-bottom: 10px;">Sign up and receive 20% off your first order.</div>
						<div class="form_box">
							<iframe
								:src="formUrl"
								width="100%"
								height="420px"
								frameborder="0"
								allowfullscreen
							>
							</iframe>
							<!-- <div id="hbspt-form-container" style="width: 100%;">
								  <script>
									(function(d, s, id) {
									  var js, fjs = d.getElementsByTagName(s)[0];
									  if (d.getElementById(id)) return;
									  js = d.createElement(s); js.id = id;
									  js.src = '//js.hsforms.net/forms/embed/v2.js';
									  fjs.parentNode.insertBefore(js, fjs);
									}(document, 'script', 'hbspt-form-script'));
								  </script>
							</div>
							   <div id="hbspt-form"
							         style="padding-left: 15px; padding-right: 15px; padding-top: 10px; padding-bottom: 10px;"
							         data-form-id="b5a03fdc-7fa3-49ec-b9cc-3d6e5ae0afe3"
							         data-form-encoding="version=1"
							         data-form-style="default"
							         data-form-cloud="">
							    </div> -->
							<!-- <div class="form_el">
								<div class="label">Email<span>*</span></div>
								<div class="input_el">
									<input v-model="emailVal" :class="isClick && !emailVal ? 'err' : ''" style="width: 95%;" />
								</div>
								<div v-show="isClick && !emailVal" class="error">Please complete this required field.</div>
							</div>
							<div class="form_box_el">
								<div class="form_el form_left">
									<div class="label">First name<span>*</span></div>
									<div class="input_el">
										<input v-model="firstVal"  :class="isClick && !firstVal ? 'err' : ''" />
									</div>
									<div v-show="isClick && !firstVal" class="error">Please complete this required field.</div>
								</div>
								<div class="form_el form_right">
									<div class="label">Last name<span>*</span></div>
									<div class="input_el">
										<input v-model="lastVal"  :class="isClick && !lastVal ? 'err' : ''" />
									</div>
									<div v-show="isClick && !lastVal" class="error">Please complete this required field.</div>
								</div>
							</div>
							<div v-show="isClick && !lastVal && !firstVal && !emailVal" class="tips_box">
								<div class="error">Please complete all required fields.</div>
							</div>
							<div class="btn_box" @click="subClick">Subscribe</div> -->
						</div>
					</div>
				</div>
				<div class="share_box">
					<a href="https://www.linkedin.com/company/cordx/" target="_blank">
						<img src="../../assets/img/路径@2x.png" />
					</a>
					<a href="https://twitter.com/cordx_us" target="_blank">
						<img src="../../assets/img/路径 1@2x.png" style="padding-top: 2px;" />
					</a>
					<a href="https://tiktok.com/@cordxusa" target="_blank">
						<img src="../../assets/img/tiktok.png" style="padding-top: 0px;" />
					</a>
					<a href="https://www.youtube.com/@CorDx3721" target="_blank">
						<img src="../../assets/img/youtube.png" style="width: 22px;padding-top: 2px;" />
					</a>
				</div>
				<div class="privacy_box">
					<div class="privacy_el1" @click="goPrivacy1">Privacy Policy</div>
					<div class="privacy_el2" @click="goPrivacy2">Terms and Conditions</div>
				</div>
			</div>
		</div>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading"><van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import { navList, formSubmit } from '@/api/public';
export default {
	name: 'ThirdPartyForm',
	components:{
		//
	},
	data() {
		return {
			isLoading: true,  //界面loading
			navData: '',  //JSON.parse(sessionStorage.getItem('navData')),
			emailVal: '',
			firstVal: '',
			lastVal: '',
			isClick: false,
			formUrl: 'https://cordx.com/hbspt-form.html?t='+new Date().getTime()
		}
	},
	created(){
		let that = this;
	},
	mounted() {
		let that = this;
		that.isLoading = false;
	},
	watch: {
		//
	},
	methods: {
		//点击提交
		subClick() {
			let that = this;
			that.isClick = true;
			if(that.emailVal && that.firstVal && that.lastVal) {
				that.$toast.loading({
					forbidClick: true,
				});
				formSubmit({
					first_name: that.firstVal,
					last_name: that.lastVal,
					email: that.emailVal,
					source: 'Other',
					type: 'Contact Us',
				}).then(res => {
					that.$toast.clear();
					that.$toast('Your form has been successfully submitted, thank you!');
					that.emailVal = '';
					that.firstVal = '';
					that.lastVal = '';
					that.isClick = false;
				});
			}
		},
		//跳转导航
		navHandle(path) {
			let that = this;
			if(that.$route.path != path) {
				that.$router.push({ path: path, });
			}
		},
		//跳转首页
		goIndex() {
			let that = this;
			if(that.$route.path != '/') {
				that.$router.push({ path: '/', });
			}
		},
		goPrivacy1() {
			this.$router.push({ path: '/privacy-policy', });
		},
		goPrivacy2() {
			this.$router.push({ path: '/terms-and-conditions', });
		},
	}
}
</script>

<style lang="less" scoped>
.main_box{
	width: 100%;
	padding: 40px 0;
	border-top: 2px solid #0B318F;
	.footer_box{
		width: 1140px;
		margin: 0 auto;
		padding: 10px;
		.privacy_box{
			padding-top: 30px;
			cursor: pointer;
			.privacy_el2{
				display: inline-block;
				padding-left: 30px;
				font-size: 18px;
			}
			.privacy_el1{
				display: inline-block;
				padding-right: 30px;
				border-right: 1px solid #E7ECF2;
				font-size: 18px;
			}
		}
		.share_box{
			img{
				width: 20px;
				display: inline-block;
				margin-right: 20px;
				cursor: pointer;
			}
		}
		.footer_main{
			display: flex;
			.left{
				flex: 1;
				display: flex;
				.left_box_el{
					flex: 1;
					div{
						padding-bottom: 5px;
						font-size: 20px;
						color: #000000;
						cursor: pointer;
					}
					a{
						color: #706B69;
					}
				}
			}
			.right{
				width: 480px;
				padding-right: 0px;
				.form_box{
					.btn_box{
						display: inline-block;
						margin-top: 30px;
						padding: 6px 20px;
						background: #0B318F;
						border-color: #0B318F;
						color: #ffffff;
						font-family: helvetica;
						cursor: pointer;
					}
					.tips_box{
						margin-top: 20px;
						.error{
							font-size: 13px;
							font-family: helvetica;
							color: #f2545b;
						}
					}
					.form_box_el{
						display: flex;
						.form_left{
							flex: 1;
						}
						.form_right{
							flex: 1;
						}
					}
					.form_el{
						width: 100%;
						margin-top: 15px;
						.input_el{
							input{
								width: 90%;
								height: 40px;
								line-height: 40px;
								padding: 9px 10px;
								background-color: #f5f8fa;
								color: #33475b;
								border: 1px solid #cbd6e2;
							}
							input.err{
								border: 1px solid #c87872;
							}
						}
						.label{
							font-size: 13px;
							font-family: helvetica;
							color: #0B318F;
							span{
								color: #f2545b;
							}
						}
						.error{
							font-size: 13px;
							font-family: helvetica;
							color: #f2545b;
						}
					}
				}
				.tit{
					font-size: 24px;
					// color: #33475b;
				}
			}
		}
		.logo_box{
			margin-bottom: 40px;
			img{
				width: 150px;
				cursor: pointer;
			}
		}
	}
}
</style>